<template>
  <div 
    :class="['photo', `is-${empIcs}`, {'emp-photo' : empId , 'company-logo-photo' : !empId }]"
    v-if="empPhotoDisplay"
  >
    <img class="emp" :src="photoImage" @error="replaceByDefault" ref="photo">
  </div>
</template>

<script>
export default {
  props: ['empId', 'empIcs', 'isVaccinated', 'largeBadge'],
  data() {
    return {
      empImageSource: 'https://file.midlandici.com/mr/img/emp_photo_80/',
      empPhotoDisplay: true,
    };
  },
  computed: {
    photoImage() {
      if (this.empId) {
        return `${this.empImageSource}${this.empId}_L_80.jpg`;
      }
      return `${this.empImageSource}mr_ics_bw_2.svg`;
    }
  },
  methods: {
    replaceByDefault() {
      this.empPhotoDisplay = false;
    },
  },
};
</script>

<style scoped>
.emp-photo {
  width: 100%;
  height: auto;
  margin-right: 5px;
  position: relative;
}

.company-logo-photo {
  width: 35px;
  height: auto;
  margin-right: 5px;
}

.emp-photo .emp {
  width: 100%;
  height: 100%;
  border: 2px solid;
  border-radius: 50%;
}

.emp-photo.is-i .emp {
  border-color: #47337C;
}

.emp-photo.is-c .emp {
  border-color: #008CBA;
}

.emp-photo.is-s .emp {
  border-color: #DA4E00;
}
</style>
